import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.create";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/es.reflect.construct";
import "core-js/modules/es.reflect.get";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import "core-js/modules/web.timers";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry

 Description:

 11/20/2018 [TB]: Removed the onclick handler and data-clickable attribute from the <div>
 element inside <Container>. The handler function (also removed) was calling event.stopPropagation.
 The onclick handler was causing JAWS to announce "clickable" for modal content. It's not clear to me
 whether this handler was serving any real purpose. Also removed the data-clickable attribute; it's not
 referenced or used anywhere else.

 12/04/2018: Restored the onclick handler to the <div> element because clicks inside the container cause
 the modal to close.
 */
import React from 'react';
import ReactDOM from 'react-dom';
import globals from '../../lib/globals/globals';
import ChildWindowHistory from './ChildWindowHistory';
import ChildWindowContent from './ChildWindowContent';
import { ChildWindowProvider } from './ChildWindowContext';
import FocusTrap from './focus-trap/FocusTrap';
import unique from '../../lib/unique-id/unique-id';
import closeChildWindow from './close-child-window/close-child-window';
import withDevice from '../with-device/with-device';
import styles from './ChildWindow.less';

var ChildWindow = function ChildWindow(ChildWindowComponent) {
  var modalRootId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'app-modal-root';

  var ChildWindow = /*#__PURE__*/function (_ChildWindowComponent) {
    _inherits(ChildWindow, _ChildWindowComponent);

    var _super = _createSuper(ChildWindow);

    function ChildWindow(props) {
      var _this;

      _classCallCheck(this, ChildWindow);

      _this = _super.call(this, props);

      _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (event) {
        if (_this.escapeCloses && 'Escape' === event.key) {
          closeChildWindow(event);
        }
      });

      _defineProperty(_assertThisInitialized(_this), "handleOverlayClick", function (event) {
        if (_this.overlayClickCloses) {
          closeChildWindow(event);
        }
      });

      _defineProperty(_assertThisInitialized(_this), "handleChildWindowClick", function (e) {
        e.stopPropagation();
      });

      _defineProperty(_assertThisInitialized(_this), "closeChildWindow", function () {
        window.history.go(-1);
        return new Promise(function (resolve) {
          setTimeout(function () {
            return resolve();
          }, 200);
        });
      });

      _this.state = Object.assign({}, _this.state, {
        childWindowId: unique(),
        ariaHeadingId: unique(),
        ariaContentId: unique()
      });
      _this.el = document.createElement('div');
      return _this;
    }

    _createClass(ChildWindow, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.modalRoot = document.getElementById(modalRootId);
        this.modalRoot.appendChild(this.el);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.modalRoot.removeChild(this.el);
      }
    }, {
      key: "render",
      value: function render() {
        var childWindowId = this.state.childWindowId; // Render the child window contents

        var elementsTree = _get(_getPrototypeOf(ChildWindow.prototype), "render", this).call(this); // Confirm that the element defines the 'isOpen' prop


        if (!elementsTree.props.hasOwnProperty('isOpen')) {
          throw new Error('ChildWindow container must define the isOpen property');
        } // Grab the props from the container element


        var _elementsTree$props = elementsTree.props,
            isOpen = _elementsTree$props.isOpen,
            afterClose = _elementsTree$props.afterClose,
            closeAction = _elementsTree$props.closeAction,
            onFrameworkClose = _elementsTree$props.onFrameworkClose,
            escapeCloses = _elementsTree$props.escapeCloses,
            containerClasses = _elementsTree$props.containerClasses,
            overlay = _elementsTree$props.overlay,
            overlayClasses = _elementsTree$props.overlayClasses,
            overlayClickCloses = _elementsTree$props.overlayClickCloses,
            ariaHide = _elementsTree$props.ariaHide,
            container = _elementsTree$props.container,
            fullHeight = _elementsTree$props.fullHeight,
            fullyResponsive = _elementsTree$props.fullyResponsive,
            target = _elementsTree$props.target,
            positioner = _elementsTree$props.positioner,
            _elementsTree$props$c = _elementsTree$props.childWindowClassName,
            childWindowClassName = _elementsTree$props$c === void 0 ? 'childWindowFlex' : _elementsTree$props$c,
            _elementsTree$props$m = _elementsTree$props.modalRef,
            modalRef = _elementsTree$props$m === void 0 ? function () {
          return undefined;
        } : _elementsTree$props$m,
            _elementsTree$props$c2 = _elementsTree$props.childWindowType,
            childWindowType = _elementsTree$props$c2 === void 0 ? 'default' : _elementsTree$props$c2,
            printable = _elementsTree$props.printable,
            _elementsTree$props$f = _elementsTree$props.focusTrapOptions,
            focusTrapOptions = _elementsTree$props$f === void 0 ? {} : _elementsTree$props$f,
            onOpenFocusDelay = _elementsTree$props.onOpenFocusDelay,
            onCloseFocusDelay = _elementsTree$props.onCloseFocusDelay,
            _elementsTree$props$a = _elementsTree$props.addAdaBoundaries,
            addAdaBoundaries = _elementsTree$props$a === void 0 ? true : _elementsTree$props$a,
            _elementsTree$props$b = _elementsTree$props.blockScrolling,
            blockScrolling = _elementsTree$props$b === void 0 ? true : _elementsTree$props$b,
            _elementsTree$props$a2 = _elementsTree$props.associateHeading,
            associateHeading = _elementsTree$props$a2 === void 0 ? true : _elementsTree$props$a2,
            _elementsTree$props$d = _elementsTree$props.describeContent,
            describeContent = _elementsTree$props$d === void 0 ? false : _elementsTree$props$d,
            setContainerRef = _elementsTree$props.setContainerRef,
            setContentRef = _elementsTree$props.setContentRef,
            savedProps = _objectWithoutProperties(_elementsTree$props, ["isOpen", "afterClose", "closeAction", "onFrameworkClose", "escapeCloses", "containerClasses", "overlay", "overlayClasses", "overlayClickCloses", "ariaHide", "container", "fullHeight", "fullyResponsive", "target", "positioner", "childWindowClassName", "modalRef", "childWindowType", "printable", "focusTrapOptions", "onOpenFocusDelay", "onCloseFocusDelay", "addAdaBoundaries", "blockScrolling", "associateHeading", "describeContent", "setContainerRef", "setContentRef"]); // Capture props that define childWindow closing behavior


        this.escapeCloses = escapeCloses;
        this.overlayClickCloses = overlayClickCloses; // Indicate which overlay to use. ChildWindowContainer defaults this to <ChildWindowOverlay>

        var Overlay = overlay; // Indicate which container to use.

        var Container = container; // Define props to add to the child window container

        var childWindowProps = {
          role: 'dialog',
          'data-en': elementsTree.props['data-en'],
          'data-modal': this.state.childWindowId
        }; // Conditionally associate the modals' heading with the modal content. When
        // there is no association, populate aria-label if the props.ariaLabel is
        // provided

        if (associateHeading) {
          childWindowProps['aria-labelledby'] = this.state.ariaHeadingId;
        } else if (this.props.ariaLabel) {
          childWindowProps['aria-label'] = this.props.ariaLabel;
        } // Conditionally associate the modal's content with the modal container. Enabled by
        // default for Dialog components only.


        if (describeContent) {
          childWindowProps['aria-describedby'] = this.state.ariaContentId;
        }

        var _focusTrapOptions = Object.assign({}, {
          clickOutsideDeactivates: true,
          ignoreFocusTrapTabs: false,
          skipFocusFirst: false,
          useAccessibilityFocus: true,
          onCreateFocusDelay: onOpenFocusDelay || globals().defaultOpenFocusDelay || 100,
          onRemoveFocusDelay: onCloseFocusDelay || globals().defaultCloseFocusDelay || 100
        }, focusTrapOptions); // Construct new props


        var props = Object.assign({}, savedProps, childWindowProps); // Return the wrapped component (rendered)

        var childWindowContent = /*#__PURE__*/React.cloneElement(elementsTree, props, elementsTree.props.children);
        var modalContent = isOpen ? /*#__PURE__*/React.createElement(ChildWindowHistory, {
          childWindowId: childWindowId,
          childWindowType: childWindowType,
          isOpened: isOpen,
          closeAction: closeAction,
          afterClose: afterClose,
          onFrameworkClose: onFrameworkClose,
          ariaHide: ariaHide,
          printable: printable
        }, /*#__PURE__*/React.createElement(Overlay, {
          childWindowId: childWindowId,
          handleClick: this.handleOverlayClick,
          handleKeyDown: this.handleKeyDown,
          className: overlayClasses,
          blockScrolling: blockScrolling
        }, /*#__PURE__*/React.createElement(FocusTrap, {
          focusTrapOptions: _focusTrapOptions,
          className: styles[childWindowClassName]
        }, /*#__PURE__*/React.createElement(Container, {
          fullHeight: fullHeight,
          fullyResponsive: fullyResponsive,
          target: target,
          positioner: positioner,
          containerClasses: containerClasses,
          setContainerRef: setContainerRef,
          setContentRef: setContentRef
        }, /*#__PURE__*/React.createElement(ChildWindowProvider, {
          value: {
            ariaHeadingId: this.state.ariaHeadingId,
            ariaContentId: this.state.ariaContentId,
            closeModal: onFrameworkClose
          }
        }, /*#__PURE__*/React.createElement(ChildWindowContent, _extends({}, props, {
          addAdaBoundaries: addAdaBoundaries,
          modalRef: modalRef,
          content: childWindowContent.props.children
        }))))))) : null;
        return /*#__PURE__*/ReactDOM.createPortal(modalContent, this.el);
      }
    }]);

    return ChildWindow;
  }(ChildWindowComponent);

  return withDevice(ChildWindow);
};

export default ChildWindow;